import {Box, CircularProgress, Grid, Typography} from '@mui/material';
import {Color} from '../../common/theme';
import {useScreenDetector} from '../../api/hook';
import {BackgroundBoxWrapper} from '../../common/components';
import {config} from '../../api/config';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { onboardNewUser } from '../../api';
import Percept from '@perceptinsight/percept-js';

const clientId = 'ud-retailer-homepages';

export const LoginScreen = () => {
    const theme = {
        backgroundColor: Color.SEA_GREEN,
        primaryTextColor: Color.WHITE,
        secondaryTextColor: Color.WHITE,
    };
    const {isDesktop} = useScreenDetector();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const campaignId = queryParams.get('campaignId');
    const campaignSource = queryParams.get('campaignSource');
    const mobileNumber = queryParams.get('mobileNumber');
    const name = queryParams.get('name');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const handleOnboarding = async () => {
            try {
                storeCampaignInfo(campaignId, campaignSource);
                if (mobileNumber && name) {
                    await onboardUser(mobileNumber, name, campaignId, campaignSource);
                    logPerceptEvent(campaignSource, campaignId, mobileNumber, name);
                }
                setIsLoading(false);
            } catch (error) {
                console.error('Error onboarding user:', error);
                setIsLoading(false);
            }
        };
        handleOnboarding();
    }, [campaignSource, campaignId, mobileNumber, name]);

    const onboardUser = async (mobileNumber: string | null, name: string | null, campaignId: string | null, campaignSource: string | null) => {
        await onboardNewUser({ 
            mobileNumber: mobileNumber || '',
            name: name || '',
            campaignInfo: {
                campaignSource: campaignSource || '',
                campaignId: campaignId || '',
            }
        });
    };

    const logPerceptEvent = (campaignSource: string | null, campaignId: string | null, mobileNumber: string | null, name: string | null) => {
        Percept.capture('SOCIALMART_USER_ONBOARED_FROM_UDAAN_APP', { 
            campaignSource: campaignSource,
            campaignId: campaignId,
            mobileNumber: mobileNumber,
            name: name
        });
    };

    const storeCampaignInfo = (campaignId: string | null, campaignSource: string | null) => {
        localStorage.setItem('campaignId', campaignId || '');
        localStorage.setItem('campaignSource', campaignSource || '');
    };
    
    const buildAuthCallbackURL = (): string => {
        const isProd = process.env.NODE_ENV === 'production';
        const hostCallbackURL = isProd ? config.prod.baseUrl : config.dev.baseUrl;
        const callbackURL = hostCallbackURL + '/auth/cb';
        return `https://auth.socialmart.com/udrh/login?cid=${clientId}&cb=${callbackURL}&v=2`;
    };

    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </div>
        );
    }

    return (
        <BackgroundBoxWrapper pTop={108} isDesktop={isDesktop} backgroundColor={theme.backgroundColor}>
            <Grid container>
                <Grid item md={8} xs={12} sm={12}>
                    <Typography
                        component={'div'}
                        variant='h4'
                        style={{
                            color: theme.primaryTextColor,
                            fontWeight: 700,
                            fontFamily: 'Poppins',
                        }}>
                        Get Started
                    </Typography>
                </Grid>
            </Grid>
            <Grid style={{marginTop: 12}} container>
                <Grid item md={12} xs={12} sm={12}>
                    <Typography
                        component={'div'}
                        variant='body1'
                        style={{
                            color: theme.secondaryTextColor,
                            fontWeight: 200,
                            fontFamily: 'Poppins',
                        }}>
                        Let's get your started. Login with your preferred method of authentication.
                    </Typography>
                </Grid>
            </Grid>
            <br />
            <Grid style={{marginTop: 12}} container>
                <Grid item md={4} xs={12} sm={12}>
                    <Box
                        style={{
                            backgroundColor: Color.FELDGRAU,
                            paddingLeft: 2,
                            paddingRight: 2,
                            paddingTop: 15,
                            paddingBottom: 15,
                            borderRadius: 32,
                            cursor: 'pointer',
                        }}>
                        <div
                            onClick={() => {
                                const authCallbackUrl = buildAuthCallbackURL();
                                window.open(authCallbackUrl);
                            }}
                            style={{
                                fontSize: 20,
                                color: Color.ASH_GRAY,
                                fontWeight: 700,
                                fontFamily: 'Poppins',
                            }}>
                            <center>Login via Udaan</center>
                        </div>
                    </Box>
                </Grid>
            </Grid>
        </BackgroundBoxWrapper>
    );
};
